import { atom } from 'jotai';
import { ImportEntityType } from '@views/MasterDataImportReview/importApi';

export interface WingmanOutboundMessage {
  type: 'flox-analyse-import';
  importId: string;
  entityType: ImportEntityType;
}

export const wingmanOutboxAtom = atom<WingmanOutboundMessage[]>([]);

export const analysedImportIdsAtom = atom<string[]>([]);
